import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class TemplateActivationEntity {
  shiftTemplateId?: string
  startDate?: string
  regions?: Array<RegionMiniEntity>
}
